import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import getJson from '../../../../method';

import "./index.scss";

import img4 from "@/assets/analysis/3.png";
import img5 from "@/assets/analysis/2.png";
import img6 from "@/assets/analysis/1.png";


@inject('store')
@observer
class index extends Component {

    render() {
        const { data } = this.props.store.analysis;
        return (
            <div className="theChart">
                <div>
                    F&B Cost %  餐饮成本率
                </div>
                <div className="other">
                    <div className="canvas-item">
                        <img src={img4} alt="" />
                        <span className="text-p">
                            {(getJson([5, 'area'], data.mtd) * 100).toFixed(3)}%
                            </span>
                        <div>
                            <span>Area Data </span>
                            <span>区域数据</span>
                        </div>
                    </div>
                    <div className="canvas-item">
                        <img src={img5} alt="" />
                        <span className="text-p">
                            {(getJson([5, 'interval'], data.mtd) * 100).toFixed(3)}%
                        </span>
                        <div>
                            <span>Revenue Range Data </span>
                            <span>收入区间数据</span>
                        </div>
                    </div>
                    <div className="canvas-item">
                        <img src={img6} alt="" />
                        <span className="text-p">
                            {(getJson([5, 'hotel'], data.mtd) * 100).toFixed(3)}%
                        </span>
                        <div>
                            <span>Hotel Data </span>
                            <span>酒店数据</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/foodBeverage.js